var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-e-text-container_user"},[_c('Editor',{attrs:{"defaultConfig":_vm.editorConfig,"mode":_vm.mode},on:{"onCreated":_vm.onCreated},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }